import { cn } from "tools/ui";
import { ICON_CHANNEL } from "../../constant/constant.jsx";
const STYLE_BASE =
  "bg-gray-200 border-2 border-gray-400 rounded-lg p-4 text-sm md:w-[142px] h-full cursor-pointer active:scale-95 transform transition-all duration-100";

const ItemFolio = ({ id, title, desc, handleClick, style, channel }) => {
  return (
    <div onClick={() => handleClick(id)} className={cn(STYLE_BASE, style)}>
      <div className="flex flex-col space-y-0 h-full items-center justify-center">
        <img
          src={ICON_CHANNEL[channel || "house"]}
          alt={channel}
          className="w-10 h-10 mb-2"
        />
        <h3 className="text-[16px] font-bold text-neutral-900">{title}</h3>
        <span>{desc}</span>
      </div>
    </div>
  );
};

export default ItemFolio;
